// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_homework,
  add_homework,
  update_homework,
  delete_homework,
  get_homework_withId,
  get_homework_filterBy,
  get_homework_filtercreated_at
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  homeworks: [],
  homeworklist: [],
  homeworkfilterlist: [],
  class_id:"",
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  ptotalPages: 0,
  ppageSize: 10,
  pcount: 0,
  pactivePage: 1,
  ploading: false,
  perror:null,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     message:"",
     title:"",
     photo:"",
     school_class:"",
     section:"",
     subject:""
  },
};
// Async Thunks for API Calls
 

// Async Thunks for API Calls
export const fetchhomework = createAsyncThunk(
  "homework/fetchhomework",
  async ({ page, page_size,school_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_homework(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchhomeworklist = createAsyncThunk(
  "homework/fetchhomeworklist",
  async (
    {  page, page_size,school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_homework(
        page, page_size,school_id,token, signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const gethomeworkwithid = createAsyncThunk(
  "homework/gethomeworkwithid",
  async ({page, page_size, school_id, token, signal,subject}, { rejectWithValue }) => {
    try {
      const response = await get_homework_withId(page, page_size, school_id, token, signal,subject);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const gethomeworkfilterby = createAsyncThunk(
  "homework/gethomeworkfilterby",
  async ({page, page_size, school_id, token, signal,filter_by}, { rejectWithValue }) => {
    try {
      const response = await get_homework_filterBy(page, page_size, school_id, token, signal,filter_by);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





export const gethomeworkfilterbycreatedat = createAsyncThunk(
  "homework/gethomeworkfilterbycreatedat",
  async ({page, page_size, school_id, token, signal,created_at}, { rejectWithValue }) => {
    try {
      const response = await get_homework_filtercreated_at(page, page_size, school_id, token, signal,created_at);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);





export const createhomework = createAsyncThunk(
  "homework/createhomework",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_homework(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const updatehomework = createAsyncThunk(
  "homework/updatehomework",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_homework(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deletehomework = createAsyncThunk(
  "homework/deletehomework",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_homework({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const homeworkSlice = createSlice({
  name: "homeworks",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        messege:"",
        teacher:""
      };
    },

    sethomework(state, action) {
      state.homeworks = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchhomework.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhomework.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworks = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchhomework.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(fetchhomeworklist.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhomeworklist.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworklist = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchhomeworklist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      
      .addCase(gethomeworkwithid.pending, (state) => {
        state.loading = true;
      })

      .addCase(gethomeworkwithid.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworkfilterlist = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(gethomeworkwithid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

        

      .addCase(gethomeworkfilterby.pending, (state) => {
        state.loading = true;
      })

      .addCase(gethomeworkfilterby.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworks = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(gethomeworkfilterby.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      
      .addCase(gethomeworkfilterbycreatedat.pending, (state) => {
        state.loading = true;
      })

      .addCase(gethomeworkfilterbycreatedat.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworks = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(gethomeworkfilterbycreatedat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })



      .addCase(createhomework.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createhomework.fulfilled, (state, action) => {
        state.addLoading = false;
        state.homeworks = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createhomework.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatehomework.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatehomework.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatehomework.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;
        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletehomework.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletehomework.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletehomework.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  sethomework,
  setActivePage,
  setpActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setSchoolId,
} = homeworkSlice.actions;
export default homeworkSlice.reducer;
